import React, { FC } from 'react';

import { Typography } from '@mui/material';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import VideoClipIcon from '../../../../assets/icons/VideoClipIcon';
import { CardLabels } from '../../../../components/Card';
import { CategoryLabel } from '../../../../components/UI/CategoryLabel';
import { DEFAULT_DISCOVER_URL } from '../../../../const';
import { colorsPalette } from '../../../../theme';
import useStyles from './styles';

interface GlossaryHitProps {
  slug: string;
  title: string;
  description: string;
  categories?: [any];
  videoUrl?: string;
  handleClickHit: () => void;
}

const GlossaryHit: FC<GlossaryHitProps> = ({
  slug,
  title,
  description,
  categories,
  videoUrl,
  handleClickHit,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const cuttedDescription = description ? description.substring(0, 299) : '';

  return (
    <div className={classes.wrapper}>
      <CardLabels>
        <CategoryLabel
          wrapperClass={classes.cardLabel}
          name={t('page.discover.glossary')}
          textColor={colorsPalette.blueDark}
          bgColor={colorsPalette.yellow}
          Icon={videoUrl ? VideoClipIcon : undefined}
          iconProps={{
            color: colorsPalette.blueDark,
          }}
        />
        {categories &&
          categories.map((category) => (
            <CategoryLabel
              wrapperClass={classes.cardLabel}
              key={category?.id}
              name={category?.title}
              withDots={false}
            />
          ))}
      </CardLabels>
      <Link to={`${DEFAULT_DISCOVER_URL}/glossary/${slug}`} onClick={handleClickHit}>
        <Typography className={classes.title} variant="h3">
          {title}
        </Typography>
      </Link>
      <Typography
        className={cn(classes.description, description?.length > 300 && classes.withDots)}
      >
        {cuttedDescription}
      </Typography>
      <Link
        className={classes.link}
        to={`${DEFAULT_DISCOVER_URL}/glossary/${slug}`}
        onClick={handleClickHit}
      >
        {t('page.discover.readMore')}
      </Link>
    </div>
  );
};

export default GlossaryHit;
